import { defineMessages } from "@edx/frontend-platform/i18n";

const messages = defineMessages({
  "notFound": {
    id: "notifications.notFound",
    defaultMessage: "Not found",
    description: "Alt text for not found image"
  },
  "noNotifications": {
    id: "notifications.noNotifications",
    defaultMessage: "No notifications to show",
    description: "Message shown when there are no notifications"
  },
  "today": {
    id: "notifications.today",
    defaultMessage: "Today",
    description: "Label for today's notifications"
  },
  "older": {
    id: "notifications.older",
    defaultMessage: "Older",
    description: "Label for older notifications"
  },
  "markAllAsRead": {
    id: "notifications.markAllAsRead",
    defaultMessage: "Mark all as read",
    description: "Button text to mark all notifications as read"
  }
});

export default messages; 